module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0146.jpg?v=689b8101";